import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import {
  type UserOrderResponseWithFlags,
  type UserOrderResponseWithFlagsSubOrdersInner,
} from '@redteclab/api/clients/bully'

import { Link } from 'base-ui'

import {
  OrderSubOrderStatus,
  userSubOrderAccessorGetSubOrderProducts,
} from '../../../../../order'

import { DirectContactFormOrderSelectionCardImageThumbnail } from './DirectContactFormOrderSelectionCardImageThumbnail'
import { DirectContactFormOrderSelectionCardSellerAndTotal } from './DirectContactFormOrderSelectionCardSellerAndTotal'

export const DirectContactFormOrderProductsSelectionCardContent: FC<{
  order: UserOrderResponseWithFlags
  selfServiceUrl: string | null
  subOrder: UserOrderResponseWithFlagsSubOrdersInner
}> = ({ order, selfServiceUrl, subOrder }) => {
  const intl = useIntl()
  const products = userSubOrderAccessorGetSubOrderProducts(subOrder)
  const cardTitle = (
    <FormattedMessage
      id="contact.ordersSection.card.title"
      values={{
        date: intl.formatDate(order.orderMasterData?.orderDate),
      }}
    />
  )

  return (
    <div className="w-full">
      <p className="mb-2 flex text-m font-medium">
        {selfServiceUrl ? (
          <Link className="z-10" color="inherit" href={selfServiceUrl} overlay>
            {cardTitle}
          </Link>
        ) : (
          cardTitle
        )}
      </p>
      <DirectContactFormOrderSelectionCardSellerAndTotal subOrder={subOrder} />
      <OrderSubOrderStatus includeNowIndicator subOrder={subOrder} />
      <DirectContactFormOrderSelectionCardImageThumbnail products={products} />
    </div>
  )
}
